<template>
  <div>
    <popup
      :show.sync="is_popup_show_detail"
      height="680px"
      width="980px"
      @on-close="close_fabric_detail"
    >
      <div class="fabric-content-wrap" style="height: 100% !important">
        <div class="info-wrap">
          <div class="flex justify-around">
          <div class="left-popup">
            <div
              v-if="
                (detail.image_list &&
                  detail.image_list.length > 0) ||
                detail.video
              "
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide v-if="detail.video">
                  <video
                    v-if="detail.video"
                    :src="detail.video"
                    muted
                    autoplay
                    controls
                    id="video-material"
                  >
                    您的浏览器不支持视频播放。
                  </video>
                </swiper-slide>
                <swiper-slide
                  v-for="(item, index) in detail.image_list"
                  :key="`sl` + index"
                >
                  <img
                    :src="(detail.image_list[curr_slider_index] || {}).url"
                    v-viewer
                    alt=""
                    class="img"
                  />
                </swiper-slide>

                <div
                  slot="button-prev"
                  class="swiper-button-prev"
                  @click.prevent.stop="onChangeSlider('prev')"
                ></div>
                <div
                  slot="button-next"
                  class="swiper-button-next"
                  @click.prevent.stop="onChangeSlider('next')"
                ></div>
              </swiper>
            </div>
            <div class="img-list-box">
              <img
                v-for="(item, index) in detail.image_list"
                :key="index"
                @click="curr_slider_index = index"
                :src="item.url"
                alt=""
                :class="['img-item', { active: index === curr_slider_index }]"
              />
            </div>
          </div>
          <div class="right" v-if="type=='fabric'">
            <p class="name">{{ detail.fabric_name_cn || detail.goods_no }}</p>
            <p class="price" v-if="detail.fabric_price > 0">
              价格:¥{{ detail.fabric_price
              }}{{
                detail.unit ? "/" + detail.unit : ""
              }}
            </p>
            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            >
              <!-- 面料参数 -->
            </div>
            <div class="list">
              <div class="item">
                <span class="key">货号：</span
                ><span class="value">{{ detail.goods_no || "-" }}</span>
              </div>
              <div class="item">
                <span class="key">分类：</span
                ><span class="value">{{ detail.category_name || "-" }}</span>
              </div>
              <div class="item">
                <span class="key">成分：</span
                ><span class="value">{{ detail.component }}</span>
              </div>
              <div class="item">
                <span class="key">克重：</span
                ><span class="value">{{ detail.weight }}</span>
              </div>
              <div class="item">
                <span class="key">幅宽：</span
                ><span class="value">{{ detail.width_desc }}</span>
              </div>
              <div class="item">
                <span class="key">国标：</span
                ><span class="value">{{ detail.standard }}</span>
              </div>
              <div class="item">
                <span class="key">织物：</span
                ><span class="value">{{ detail.zhiwu || "-" }}</span>
              </div>
              <div class="item">
                <span class="key">面料功能：</span
                ><span class="value">{{ detail.gongneng || "-" }}</span>
              </div>
              <div class="item">
                <span class="key">织法：</span
                ><span class="value">{{ detail.zhifa || "-" }}</span>
              </div>
              <div class="item">
                <span class="key">单位：</span
                ><span class="value">{{ detail.unit }}</span>
              </div>
              <div class="item">
                <span class="key" style="">提供寄样服务：</span
                ><span class="value">{{
                  detail.is_support_send_sample ? "是" : "否"
                }}</span>
              </div>
              <template v-if="matched_label_groups.length">
                <div
                  class="item"
                  v-for="(group, gIndex) in matched_label_groups"
                  :key="gIndex"
                >
                  <span class="key">{{ group.label_name }}：</span>
                  <span class="value">
                    <span
                      class="label-tag"
                      v-for="(item, iIndex) in group.items"
                      :key="iIndex"
                    >{{ item.name }}</span>
                  </span>
                </div>
              </template>
            </div>
          </div>
          <div class="right" v-if="type=='accessory'">
            <p class="name">{{ detail.accessory_name }}</p>
            <p class="no">
              辅料编号：{{ detail.accessory_sku }}
            </p>
            <div class="title" style="border-top: 1px solid #e0e0e0">
              <!-- 辅料参数 -->
            </div>
            <div class="list">
              <div class="item">
                <span class="key">单位：</span
                ><span class="value">{{
                  detail.measure_unit
                }}</span>
              </div>
              <div class="item">
                <span class="key">规格：</span
                ><span class="value">{{ detail.spec }}</span>
              </div>
              <div class="item">
                <span class="key">材质：</span
                ><span class="value">{{
                  detail.material
                }}</span>
              </div>
              <template v-if="matched_label_groups.length">
                <div
                  class="item"
                  v-for="(group, gIndex) in matched_label_groups"
                  :key="gIndex"
                >
                  <span class="key">{{ group.label_name }}：</span>
                  <span class="value">
                    <span
                      class="label-tag"
                      v-for="(item, iIndex) in group.items"
                      :key="iIndex"
                    >{{ item.name }}</span>
                  </span>
                </div>
              </template>
            </div>
          </div>
          </div>
        </div>
        <template v-if="detail.color_list && detail.color_list.length">
          <div class="color-title">
            颜色分类({{ detail.color_list.length }}):
          </div>
          <div class="color-box">
            <div
              v-for="(item, index) in detail.color_list"
              :key="index"
              :class="[
                'color-items',
                { active: detail.color_name_cn === item.color_name_cn },
              ]"
            >
              <div class="item-top">
                <span
                  class="color-img"
                  v-if="item.rgb"
                  :style="{ 'background-color': item.rgb }"
                ></span>
                <img
                  v-else
                  v-viewer
                  @click.stop
                  :src="item.color_value | default_img"
                  alt=""
                  class="color-img"
                />
                <div class="color-name" :title="`${item.color_name_cn}`">
                  {{ item.color_name_cn }}
                </div>
              </div>
              <div class="info-item">
                <div class="label">C卡色号:</div>
                <div class="value">{{ item.pantoneC }}</div>
              </div>
              <div class="info-item">
                <div class="label">TCX色号:</div>
                <div class="value">{{ item.pantoneTcx }}</div>
              </div>
              <div class="info-item">
                <div class="label">TPG色号:</div>
                <div class="value">{{ item.pantoneTpg }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="detail.description">
          <div class="title-box">
            <div class="title">产品详情</div>
            <div class="line"></div>
          </div>
          <div
            class="richtext-wrap"
            v-html="detail.description"
          ></div>
        </template>
      </div>
    </popup>
  </div>
</template>

<script>
import {
  AccessoryLabelList,
  FabricLabelList,
  GetAccessory,
  GetFabric,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "FabricAccessoryShow",
  props: {},
  data() {
    return {
      is_popup_show_detail: false,
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (document.getElementById("video-material")) {
              if (this.activeIndex === 0) {
                document.getElementById("video-material").play();
              } else {
                document.getElementById("video-material").pause();
              }
            }
          },
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      id: 0,
      type: "fabric",
      detail: {
        image_list: [],
        color_list: [],
        label_ids: [],
      },
      label_list: [],
      curr_slider_index: 0,
    };
  },
   components: {
    Popup,
    swiper,
    swiperSlide,
  },
  computed: {
    matched_label_groups() {
      const ids = this.detail.label_ids || [];
      if (!ids.length) return [];
      const result = [];
      for (const group of this.label_list) {
        const matched = group.content.filter((item) =>
          ids.includes(item.id)
        );
        if (matched.length) {
          result.push({
            label_name: group.label_name,
            items: matched,
          });
        }
      }
      return result;
    },
  },
  watch: {},
  methods: {
    show(id, type) {
      this.id = id;
      this.type = type;
      this.curr_slider_index = 0;
      this.get();
    },
    close_fabric_detail() {
        this.is_popup_show_detail = false
    },
    onChangeSlider(type) {
      const image_list = this.detail.image_list || [];
      if (!image_list.length) return;
      const { curr_slider_index } = this;
      if (curr_slider_index === 0 && type === "prev") {
        this.curr_slider_index = image_list.length - 1;
        return;
      }
      if (
        curr_slider_index === image_list.length - 1 &&
        type === "next"
      ) {
        this.curr_slider_index = 0;
        return;
      }
      this.curr_slider_index =
        type == "prev" ? curr_slider_index - 1 : curr_slider_index + 1;
    },
    async get() {
      if (this.type == "fabric") {
        var { data } = await GetFabric({
          id: this.id,
        });
      } else {
        var { data } = await GetAccessory({
          id: this.id,
        });
      }
      this.detail = data;

      let labelRes;
      if (this.type == "fabric") {
        labelRes = await FabricLabelList();
      } else {
        labelRes = await AccessoryLabelList();
      }
      this.label_list = labelRes.data || [];
      this.is_popup_show_detail = true;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.fabric-content-wrap {
  margin-top: 40px;
  overflow-y: scroll;
  height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }
    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    min-height: 430px;

    .left-popup {
      width: 420px;
      .f-img {
        width: 420px;
        height: 420px;
      }
    }

    .img-list-box {
      display: flex;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;
      .img-item {
        width: 50px;
        height: 50px;
        border: 2px solid #e0e0e0;
        border-radius: 10px;
        cursor: pointer;
        &.active,
        &:hover {
          border: 2px solid #fa3d5a;
        }
      }
    }

    .right {
      // width: 500px;
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        // margin: 25px 0;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }

        .label-tag {
          color: #1a1a1a;
          font-size: 13px;
          margin-right: 8px;
        }
      }
    }
  }

  .color-title {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: bold;
    margin-top: 40px;
  }
  .color-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
    .color-items {
      user-select: none;
      width: 170px;
      border: 1px solid #e3e3e3;
      border-radius: 4px;
      padding: 8px;
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      &.active {
        border: 1px solid #ff5967;
      }
      .item-top {
        display: flex;
        align-items: center;
        column-gap: 8px;
        .color-img {
          width: 30px;
          height: 30px;
          border: 1px solid #e3e3e3;
          border-radius: 4px;
          flex-shrink: 0;
        }
        .color-name {
          font-size: 12px;
          color: #333;
          font-weight: 500;
        }
      }
      .info-item {
        display: flex;
        align-items: center;
        column-gap: 5px;
        .label {
          color: #999;
          font-size: 12px;
          flex-shrink: 0;
        }
        .value {
          color: #666;
          font-size: 12px;
          white-space: pre-wrap;
          word-break: break-all;
        }
      }
    }
  }

  .richtext-wrap {
    flex: 1;
    padding-bottom: 60px;
  }
  .btn-box {
    display: flex;
    justify-content: center;
    column-gap: 20px;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background: #ffffff;
    padding: 10px 0;
    .cancel-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      color: #1a1a1a;
      font-size: 14px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #1a1a1a;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;
  border: 1px solid #e5e5e5;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img,
  video {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

::v-deep .viewer-container {
  z-index: 999999 !important;
}

::v-deep .ivu-upload {
  width: 100%;
}
</style>
